import React from 'react';

interface IConfigNotStartedIconProps {
	id?: string;
}

export const ConfigNotStarted = ({ id = 'configNotStarted' }: IConfigNotStartedIconProps) => {
	return (
		<svg width="300" height="161" viewBox="0 0 300 161" fill="none" xmlns="http://www.w3.org/2000/svg">
			<title id={id}>configuration not started illustration</title>
			<g clipPath="url(#clip0_9877_21782)">
				<path
					d="M223.003 83.032C224.629 139.263 177.227 117.134 157.438 142.093C137.65 167.052 98.9141 163.959 87.9109 127.223C76.9077 90.4881 85.8298 16.6175 154.935 14.9923C206.363 13.7829 222.028 49.2837 223.003 83.032Z"
					fill="#EBEBEB"
				/>
				<rect
					x="94.2233"
					y="95.3347"
					width="127"
					height="41"
					rx="3"
					transform="rotate(-14.8792 94.2233 95.3347)"
					fill="white"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<path
					d="M192.859 74.63L142.825 87.9236C142.22 88.0842 141.846 88.6516 141.988 89.191L143.557 95.1279C143.699 95.6673 144.304 95.9744 144.909 95.8138L194.943 82.5203C195.547 82.3597 195.922 81.7922 195.779 81.2528L194.211 75.3159C194.069 74.7765 193.463 74.4694 192.859 74.63Z"
					fill="#ffcc00"
				/>
				<path
					d="M133.548 90.2295L103.035 98.3367C102.666 98.4346 102.804 100.168 103.343 102.209L109.275 124.669C109.814 126.709 110.55 128.284 110.919 128.186L141.432 120.079C141.801 119.981 141.663 118.247 141.124 116.207L135.192 93.7469C134.653 91.7064 133.917 90.1316 133.548 90.2295Z"
					fill="#EBEBEB"
				/>
				<path
					d="M188.722 90.5999L146.333 101.862C145.82 101.998 145.521 102.546 145.663 103.085L147.231 109.022C147.374 109.562 147.904 109.889 148.417 109.753L190.806 98.4901C191.318 98.354 191.617 97.8065 191.475 97.2671L189.907 91.3302C189.764 90.7908 189.234 90.4638 188.722 90.5999Z"
					fill="#EBEBEB"
				/>
				<path
					d="M210.142 91.3052C212.617 90.6476 214.294 88.8639 213.886 87.3213C213.479 85.7787 211.142 85.0613 208.667 85.719C206.191 86.3766 204.515 88.1603 204.922 89.7029C205.33 91.2455 207.667 91.9629 210.142 91.3052Z"
					fill="#EBEBEB"
				/>
				<rect
					x="81.7755"
					y="44.5639"
					width="127"
					height="41"
					rx="3"
					transform="rotate(3.78789 81.7755 44.5639)"
					fill="white"
					stroke="#A6A6A6"
					strokeWidth="2"
				/>
				<path
					d="M181.849 56.5185L130.192 53.0985C129.568 53.0572 129.032 53.4749 128.994 54.0315L128.58 60.158C128.542 60.7146 129.017 61.1994 129.641 61.2407L181.298 64.6607C181.922 64.702 182.458 64.2843 182.496 63.7277L182.911 57.6012C182.948 57.0446 182.473 56.5599 181.849 56.5185Z"
					fill="#ffcc00"
				/>
				<path
					d="M120.666 52.3141L89.1628 50.2284C88.7822 50.2032 88.3581 51.8898 88.2156 53.9955L86.647 77.1725C86.5045 79.2782 86.6975 81.0057 87.0781 81.0309L118.581 83.1167C118.962 83.1418 119.386 81.4552 119.528 79.3495L121.097 56.1725C121.24 54.0668 121.047 52.3393 120.666 52.3141Z"
					fill="#EBEBEB"
				/>
				<path
					d="M172.818 70.3242L129.054 67.4267C128.525 67.3917 128.066 67.8145 128.028 68.3711L127.614 74.4976C127.576 75.0542 127.974 75.5338 128.503 75.5688L172.267 78.4663C172.796 78.5014 173.255 78.0785 173.292 77.5219L173.707 71.3954C173.745 70.8388 173.347 70.3592 172.818 70.3242Z"
					fill="#EBEBEB"
				/>
				<path
					d="M192.886 77.8485C195.441 78.0177 197.6 76.8644 197.708 75.2725C197.816 73.6807 195.831 72.253 193.276 72.0838C190.72 71.9146 188.561 73.0679 188.453 74.6598C188.346 76.2517 190.33 77.6793 192.886 77.8485Z"
					fill="#EBEBEB"
				/>
			</g>
			<defs>
				<clipPath id="clip0_9877_21782">
					<rect width="300" height="160" fill="white" transform="translate(0 0.5)" />
				</clipPath>
			</defs>
		</svg>
	);
};
